import React from "react";
import "./RemoteAccessIndicator.css";

const G = window.glob;

const RemoteAccessIndicator = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { qt: 0, active: false };
		this.uid = G.generateUid("RemoteAccessIndicator");
	}
	componentDidMount() {
		G.register('remoteAccessCounter', c => {
			this.setState({ qt: c, active: ( c > 0) });
		}, this.uid);
	}
	componentWillUnmount() {
		G.unregister('remoteAccessCounter', this.uid);
	}
	render() {
		return(
			<div
				className={"RemoteAccessIndicator "+(this.state.active ? 'active' : 'inactive')}
				id={this.uid}
			>
				{ [...Array(this.state.qt || 1 )].map( (a,c)=> <span key={c} /> )}
			</div>
		);
	}
}

export default RemoteAccessIndicator;